import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import "../Lib/react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import "./Founder.css"

function App() {
    return <CardCarousel {...CardCarouselData} />;
}

export default App;

function CardCarousel(props) {
    const {
        group273Props,
        group2732Props,
    } = props;

        return (
                <div className="founder-d">
                    {/* <Row> */}
                    <Group273
                    ellipse1={group273Props.ellipse1}
                    text278={group273Props.text278}
                    name={group273Props.name}
                    text279={group273Props.text279}
                    />
                    <Group273
                    text278={group2732Props.text278}
                    ellipse1={group2732Props.ellipse1}
                    name={group2732Props.name}
                    text279={group2732Props.text279}
                    className={group2732Props.className}
                    /> 
                  {/* </Row> */}
                </div>
  
        );
}


function Group273(props) {
    const { text278, ellipse1, name, text279, className } = props;
  
    return (
      <div className={`lpd-group-27 ${className || ""}`}>
        <div className="lpd-overlap-group-1 lpd-card-2">
          
          <div className="lpd-group-120">
            <img className="lpd-ellipse-1 ellipse-1-img"  src={ellipse1} />
            {/* {home_page.map(item =>
              <>
                {
                  item.Ellipse1.map(data =>
                    <img className="lpd-ellipse-1" src={data.url} />
                    )
                }
              </>
              )
            } */}
            <div className="lpd-flex-col-1">
              <div className="lpd-name lpd-valign-text-middle lpd-typographyheadlineh3-extrabold-30">{name}</div>
              <div className="lpd-text-5-2 lpd-valign-text-middle lpd-typographybody16-regular">{text279}</div>
            </div>
          </div>
          <p className="lpd-text-5-1 lpd-typographybodycaption-14-semi-bold">{text278}</p>
        </div>
      </div>
    );
  }

  const group273Data = {
    text278: <>Mr. Ganesh is a Structural Engineering expert with 20 years of experience in Commercial, Residential Building, and Notable Projects in Constructions & Structural Designing. 
    <br/><br/>In possession of proven expertise in design and analysis of Structures, Civil Construction, and Project Management experienced in Mumbai International Airport Limited – T2B, Mumbai Mono-Rail & also in designing Stations. And in tenure with GEODESIC Techniques, W S ATKINS: BNS Station, THS Station, NPS Station.
</>,
    ellipse1: "./Images/About_US/Ganesh-profile.png",
    name: "Ganesh S Reddy",
    text279: "M.Tech (Structures)- Founder",
};

const group2732Data = {
    text278: <>Committed to excellence in project management and construction industry, Mr. Hari is a passionate man who loves challenges. With over 9 years of expertise, he is known for successfully identifying target accounts and developing cordial relationships to enhance existing businesses and attain excellence.
    <br/><br/>He is skilled in designing and implementing competitive business development strategies; and is associated with several reputed organizations like Saint Gobain, Bosch & GE in Bengaluru.</>,
    ellipse1: "./Images/About_US/Harikishna-profile.png",
    name: "Hari Krishna S Reddy",
    text279: "Co-Founder",
    className: "lpd-group-27-1",
};
  

const CardCarouselData  = {
    group273Props: group273Data,
    group2732Props: group2732Data,
};